import { render } from "./BillList.vue?vue&type=template&id=06c4e8e8"
import script from "./BillList.vue?vue&type=script&lang=js"
export * from "./BillList.vue?vue&type=script&lang=js"

import "./BillList.vue?vue&type=style&index=0&id=06c4e8e8&lang=css"

import exportComponent from "/data/deploy/code/save-ocr-ionic/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__